import styled from 'styled-components'

import { Button, TButtonProps } from 'elements/button/Button'

export const ConnectButton = styled(Button)<TButtonProps>`
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px 0px;

  background: linear-gradient(45deg, ${(p) => p.theme.colors.yellow} 0%, ${(p) => p.theme.colors.orange} 100%);
`

ConnectButton.defaultProps = {
  colors: 'yellow',
  borderColor: 'yellow',
  size: 'bigger',
  type: 'submit',
  w: '100%',
  m: '10px 0',
}
